<div class="group2">
  <h4 *ngIf="!hidetitle"> Compta </h4>

  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt49">
    <label class="col-sm-3 champ" style="padding:0px">Effectif :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit && common.visibleChamp.cltObj49.vision"> {{ (detail.efectif || '0') }} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.efectif" 
        [hidden]="!common.visibleChamp.cltObj49.vision"
        [disabled]="!droit.droitFicheCompta || (add && !common.visibleChamp.cltObj49.creation) || (!add && edit && !common.visibleChamp.cltObj49.modifiable)">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt50 && common.visibleChamp.cltObj50.visible">
    <label class="col-sm-3 champ" style="padding:0px">% Groupe :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit && common.visibleChamp.cltObj50.vision"> {{ (detail.pourcentage ? Tofixed(detail.pourcentage) : default.toFixed(nbdigit))  }}
        <!-- à formaté-->
      </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.pourcentage" 
        [hidden]="!common.visibleChamp.cltObj50.vision"
        [disabled]="!droit.droitFicheCompta || (add && !common.visibleChamp.cltObj50.creation) || (!add && edit && !common.visibleChamp.cltObj50.modifiable)">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt51 && common.visibleChamp.cltObj51.visible">
    <label class="col-sm-3 champ" style="padding:0px">TVA intra :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit && common.visibleChamp.cltObj51.vision "> {{ (detail.codeTVAIntra) }} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.codeTVAIntra" 
        [hidden]="!common.visibleChamp.cltObj51.vision"
        [disabled]="!droit.droitFicheCompta || (add && !common.visibleChamp.cltObj51.creation) || (!add && edit && !common.visibleChamp.cltObj51.modifiable) || masqueModificationExterne">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt52 && common.visibleChamp.cltObj52.visible">
    <label class="col-sm-3 champ" style="padding:0px">TVA :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input type="checkbox" *ngIf="common.visibleChamp.cltObj52.vision" id="checkbox-1-1 "
        class="regular-checkbox regular-checkbox-checked"
        [disabled]="!edit || !droit.droitFicheCompta || (add && !common.visibleChamp.cltObj52.creation) || (!add && edit && !common.visibleChamp.cltObj52.modifiable)"
        [(ngModel)]="detail.isTVA">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt52 && common.visibleChamp.cltObj52.visible">
    <label class="col-sm-3 champ" style="padding:0px">Taux TVA :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit && common.visibleChamp.cltObj52.visible"> {{ (detail.txTVA ? Tofixed(detail.txTVA) : default.toFixed(nbdigit)) }}
        <!-- à formaté-->
      </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.txTVA" 
        [hidden]="!common.visibleChamp.cltObj52.vision"
        [disabled]="!droit.droitFicheCompta || (add && !common.visibleChamp.cltObj52.creation) || (!add && edit && !common.visibleChamp.cltObj52.modifiable)">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt53 && common.visibleChamp.cltObj53.visible">
    <label class="col-sm-3 champ" style="padding:0px">Régime TVA :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">

      <div *ngIf="!edit && common.visibleChamp.cltObj53.vision"> {{ ((detail.regimeTVA - 1) === 0 ? 'Exonéré de TVA' : 'TVA de plein droit') }} </div>
      <div *ngIf="edit">
        <div *ngIf="droit.droitFicheCompta && common.visibleChamp.cltObj53.vision"
          [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj53.creation) || (!add && edit && !common.visibleChamp.cltObj53.modifiable)}">
          <app-autocomplete (selectfunction)="selectedRegime = $event; detail.regimeTVA = $event.id "
            [results]="regimeTva" [highlight]="true" [id]="'modedepaie'" [isCombo]="true"
            [defaultselected]="selectedRegime" [disablefocus]="true"
            [defaultsearch]="selectedRegime ? selectedRegime.libelleObjetEntite : ''"></app-autocomplete>
        </div>
        <div *ngIf="!droit.droitFicheCompta && common.visibleChamp.cltObj53.vision">
          {{ (selectedRegime ? selectedRegime.libelleObjetEntite : '')
          }}
        </div>
      </div>
    </div>
  </div>

  <div class="form-group items col-sm-12"
    *ngIf="societe.isTGC && common.visibleChamp.clt209 && common.visibleChamp.cltObj209.visible">
    <label class="col-sm-3 champ" style="padding:0px">TVA Achat :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit && common.visibleChamp.cltObj209.visible"> {{ (detail.tauxTVAAchat ? Tofixed(detail.tauxTVAAchat) : default.toFixed(nbdigit)) }}
      </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.tauxTVAAchat" 
        [hidden]="!common.visibleChamp.cltObj209.vision"
        [disabled]="!droit.droitFicheCompta || (add && !common.visibleChamp.cltObj209.creation) || (!add && edit && !common.visibleChamp.cltObj209.modifiable)">
    </div>
  </div>

  <div class="form-group items col-sm-12"
    *ngIf="societe.isTGC && common.visibleChamp.clt210 && common.visibleChamp.cltObj210.visible">
    <label class="col-sm-3 champ" style="padding:0px">Franchise TGC :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input *ngIf="common.visibleChamp.cltObj210.vision" type="checkbox" id="checkbox-1-1 "
        class="regular-checkbox regular-checkbox-checked"
        [disabled]="!edit || !droit.droitFicheCompta || (add && !common.visibleChamp.cltObj210.creation) || (!add && edit && !common.visibleChamp.cltObj210.modifiable)"
        [(ngModel)]="detail.isFranchise">
    </div>
  </div>

  <div class="form-group items col-sm-12"
    *ngIf="societe.isTGC && common.visibleChamp.clt211 && common.visibleChamp.cltObj211.visible">
    <label class="col-sm-3 champ" style="padding:0px">Soumis TSS :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input *ngIf="common.visibleChamp.cltObj211.vision" type="checkbox" id="checkbox-1-1 "
        class="regular-checkbox regular-checkbox-checked"
        [disabled]="!edit || !droit.droitFicheCompta || (add && !common.visibleChamp.cltObj211.creation) || (!add && edit && !common.visibleChamp.cltObj211.modifiable)"
        [(ngModel)]="detail.isTSS">
    </div>
  </div>

  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt54 && common.visibleChamp.cltObj54.visible">
    <label class="col-sm-3 champ" style="padding:0px">ID TVA :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit && common.visibleChamp.cltObj54.vision"> {{ (detail.idTVA)  }} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.idTVA" 
        [hidden]="!common.visibleChamp.cltObj54.vision"
        [disabled]="!droit.droitFicheCompta || (add && !common.visibleChamp.cltObj54.creation) || (!add && edit && !common.visibleChamp.cltObj54.modifiable)">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt55 && common.visibleChamp.cltObj55.visible">
    <label class="col-sm-3 champ" style="padding:0px">Seuil TVA :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit && common.visibleChamp.cltObj55.vision"> {{ (detail.seuilTVA ? Tofixed(detail.seuilTVA) : default.toFixed(nbdigit))  }}
        <!-- à formaté-->
      </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.seuilTVA" 
        [hidden]="!common.visibleChamp.cltObj55.vision"
        [disabled]="!droit.droitFicheCompta || (add && !common.visibleChamp.cltObj55.creation) || (!add && edit && !common.visibleChamp.cltObj55.modifiable)">
    </div>
  </div>

  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt57 && common.visibleChamp.cltObj57.visible">
    <label class="col-sm-3 champ" style="padding:0px">1 Fact.par agence :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input *ngIf="common.visibleChamp.cltObj57.vision" type="checkbox" id="checkbox-1-1 "
        class="regular-checkbox regular-checkbox-checked"
        [disabled]="!edit || !droit.droitFicheCompta || (add && !common.visibleChamp.cltObj57.creation) || (!add && edit && !common.visibleChamp.cltObj57.modifiable)"
        [(ngModel)]="detail.factAgence" (ngModelChange)="onChangeFAct('factAgence')">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt59 && common.visibleChamp.cltObj59.visible">
    <label class="col-sm-3 champ" style="padding:0px">Fact. ad. agence :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input *ngIf="common.visibleChamp.cltObj59.vision" type="checkbox" id="checkbox-1-1 "
        class="regular-checkbox regular-checkbox-checked"
        [disabled]="!detail.factAgence || !edit || (add && !common.visibleChamp.cltObj59.creation) || (!add && edit && !common.visibleChamp.cltObj59.modifiable)"
        [(ngModel)]="detail.factParAgence" [disabled]="!droit.droitFicheCompta">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt56 && common.visibleChamp.cltObj56.visible">
    <label class="col-sm-3 champ" style="padding:0px">1 Fact par chant. :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input *ngIf="common.visibleChamp.cltObj56.vision" type="checkbox" id="checkbox-1-1 "
        class="regular-checkbox regular-checkbox-checked"
        [disabled]="!edit || !droit.droitFicheCompta || (add && !common.visibleChamp.cltObj56.creation) || (!add && edit && !common.visibleChamp.cltObj56.modifiable)"
        [(ngModel)]="detail.isFactChantier" (ngModelChange)="onChangeFAct('isFactChantier')">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt58 && common.visibleChamp.cltObj58.visible">
    <label class="col-sm-3 champ" style="padding:0px">Fact. ad. chant. :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input *ngIf="common.visibleChamp.cltObj58.vision" type="checkbox" id="checkbox-1-1 "
        class="regular-checkbox regular-checkbox-checked"
        [disabled]="!detail.isFactChantier || !edit || !droit.droitFicheCompta || (add && !common.visibleChamp.cltObj58.creation) || (!add && edit && !common.visibleChamp.cltObj58.modifiable)"
        [(ngModel)]="detail.isFactParChantier">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt60 && common.visibleChamp.cltObj60.visible">
    <label class="col-sm-3 champ" style="padding:0px">Fact. synthétique :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input *ngIf="common.visibleChamp.cltObj60.vision" type="checkbox" id="checkbox-1-1 "
        class="regular-checkbox regular-checkbox-checked"
        [disabled]="!edit || !droit.droitFicheCompta || (add && !common.visibleChamp.cltObj60.creation) || (!add && edit && !common.visibleChamp.cltObj60.modifiable)"
        [(ngModel)]="detail.isFactSynth">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt61 && common.visibleChamp.cltObj61.visible">
    <label class="col-sm-3 champ" style="padding:0px">BA synthétique :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input *ngIf="common.visibleChamp.cltObj61.vision" type="checkbox" id="checkbox-1-1 "
        class="regular-checkbox regular-checkbox-checked"
        [disabled]="!edit || !droit.droitFicheCompta || (add && !common.visibleChamp.cltObj61.creation) || (!add && edit && !common.visibleChamp.cltObj61.modifiable)"
        [(ngModel)]="detail.BASynth">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt62 && common.visibleChamp.cltObj62.visible">
    <label class="col-sm-3 champ" style="padding:0px"> Comp. compta. 
      <span class="champobligatoire" *ngIf="isComptaClientObligatoire"> * </span>  :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit && common.visibleChamp.cltObj62.vision"> {{ (detail.compteComptable) }} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.compteComptable" 
        [hidden]="!common.visibleChamp.cltObj62.vision"
        [disabled]="!droit.droitFicheCompta || (add && !common.visibleChamp.cltObj62.creation) || (!add && edit && !common.visibleChamp.cltObj62.modifiable) || masqueModificationExterne">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt63 && common.visibleChamp.cltObj63.visible">
    <label class="col-sm-3 champ" style="padding:0px"> Comp. compta. F :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit && common.visibleChamp.cltObj63.vision"> {{ (detail.compteComptableFournisseur)  }}
      </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.compteComptableFournisseur" 
        [hidden]="!common.visibleChamp.cltObj63.vision"
        [disabled]="!droit.droitFicheCompta || (add && !common.visibleChamp.cltObj63.creation) || (!add && edit && !common.visibleChamp.cltObj63.modifiable) || masqueModificationExterne">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt64 && common.visibleChamp.cltObj64.visible">
    <label class="col-sm-3 champ" style="padding:0px"> Comp. coll. :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit && common.visibleChamp.cltObj64.vision"> {{ (detail.compteCollectif)  }} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.compteCollectif" 
        [hidden]="!common.visibleChamp.cltObj64.vision"
        [disabled]="!droit.droitFicheCompta || (add && !common.visibleChamp.cltObj64.creation) || (!add && edit && !common.visibleChamp.cltObj64.modifiable)">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt233 && common.visibleChamp.cltObj233.visible">
    <label class="col-sm-3 champ" style="padding:0px"> Compte Coll./TVA :</label>
    <div *ngIf="droit.droitFicheCompta" class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
      [ngClass]="{'disabledbutton': !edit || (add && !common.visibleChamp.cltObj233.creation) || (!add && edit && !common.visibleChamp.cltObj233.modifiable)}"
      (click)="showCompteCollTVA()">
      Définir
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt65 && common.visibleChamp.cltObj65.visible">
    <label class="col-sm-3 champ" style="padding:0px">Comp. coll. F :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit && common.visibleChamp.cltObj65.vision"> {{ (detail.compteCollectifF)  }} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.compteCollectifF" 
        [hidden]="!common.visibleChamp.cltObj65.vision"
        [disabled]="!droit.droitFicheCompta || (add && !common.visibleChamp.cltObj65.creation) || (!add && edit && !common.visibleChamp.cltObj65.modifiable)">
    </div>
  </div>

  <div class="form-group items col-sm-12"
    *ngIf="societe.compteCollectifDNI && common.visibleChamp.clt184 && common.visibleChamp.cltObj184.visible">
    <label class="col-sm-3 champ" style="padding:0px">Comp Coll DNI :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit && common.visibleChamp.cltObj184.vision"> {{ (detail.compteCollectifDNI)  }} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.compteCollectifDNI" 
        [hidden]="!common.visibleChamp.cltObj184.vision"
        [disabled]="!droit.droitFicheCompta || (add && !common.visibleChamp.cltObj184.creation) || (!add && edit && !common.visibleChamp.cltObj184.modifiable)">
    </div>
  </div>

  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt66 && common.visibleChamp.cltObj66.visible">
    <label class="col-sm-3 champ" style="padding:0px">Axe analytique :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit && common.visibleChamp.cltObj66.vision"> {{ (detail.axeAnalytique)  }} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.axeAnalytique" 
        [hidden]="!common.visibleChamp.cltObj66.vision"
        [disabled]="!droit.droitFicheCompta || (add && !common.visibleChamp.cltObj66.creation) || (!add && edit && !common.visibleChamp.cltObj213.modifiable)">
    </div>
  </div>

  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt213 && common.visibleChamp.cltObj213.visible">
    <label class="col-sm-3 champ" style="padding:0px">Axe ana. Achat :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit && common.visibleChamp.cltObj213.vision"> {{ (detail.axeAnalytiqueAchat)  }} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.axeAnalytiqueAchat" 
        [hidden]="!common.visibleChamp.cltObj213.vision"
        [disabled]="!droit.droitFicheCompta || (add && !common.visibleChamp.cltObj213.creation) || (!add && edit && !common.visibleChamp.cltObj66.modifiable)">
    </div>
  </div>

  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt67 && common.visibleChamp.cltObj67.visible">
    <label class="col-sm-3 champ" style="padding:0px"> IBAN+BIC :</label>
    <div *ngIf="droit.droitFicheCompta" class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
      [ngClass]="{'disabledbutton': !edit || (add && !common.visibleChamp.cltObj67.creation) || (!add && edit && !common.visibleChamp.cltObj67.modifiable)}"
      (click)="showIBANBIC()">
      Afficher
    </div>
    <div *ngIf="!droit.droitFicheCompta" class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
      [ngClass]="{'disabledbutton': !edit || (add && !common.visibleChamp.cltObj67.creation) || (!add && edit && !common.visibleChamp.cltObj67.modifiable)}">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt68 && common.visibleChamp.cltObj68.visible">
    <label class="col-sm-3 champ" style="padding:0px"> trop percu :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div  *ngIf="common.visibleChamp.cltObj68.vision" > {{ (detail.montantTropPercu ? detail.montantTropPercu.toFixed(nbdigit) :
        default.toFixed(nbdigit)) }}
        <!--à formater-->
      </div>
      <!--input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.montantTropPercu"-->
      <div *ngIf="droit.droitFicheCompta" class="col-sm-12 champ text-underline historique" style="padding: 0px"
        [ngClass]="{'disabledbutton': !edit || add || (add && !common.visibleChamp.cltObj68.creation) || (!add && edit && !common.visibleChamp.cltObj68.modifiable)}"
        (click)="showTropPercus()">
        Afficher
      </div>
    </div>
  </div>

  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt232 && common.visibleChamp.cltObj232.visible">
    <label class="col-sm-3 champ" style="padding:0px"> RUM :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="droit.droitFicheCompta" class="col-sm-12 champ text-underline historique" style="padding: 0px"
        [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj232.creation) || (!add && edit && !common.visibleChamp.cltObj232.modifiable)}"
        (click)="showRUM()">
        Afficher
      </div>
    </div>
  </div>

  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt212 && common.visibleChamp.cltObj212.visible">
    <label class="col-sm-3 champ" style="padding:0px"> Compte Paiement :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <!--param societe : listCompte => id -->
      <!-- <div *ngIf="!edit"> {{ compte }}</div> -->
      <div *ngIf="!edit"> {{ detail.comptePaiement ? detail.comptePaiement.numCompte ? ((detail.comptePaiement.nomBanque
        ? (detail.comptePaiement.nomBanque + ' / ') : '') + detail.comptePaiement.numCompte) : compte : '' }}</div>
      <div *ngIf="edit">
        <div *ngIf="droit.droitFicheCompta"
          [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj212.creation) || (!add && edit && !common.visibleChamp.cltObj212.modifiable)}">
          <app-autocomplete (searchfunction)="searchCompte($event)" (selectfunction)="detail.comptePaiement = $event"
            [disablefocus]="true" [results]="listCompte" [highlight]="true" [id]="'modedepaie'" [isCombo]="true"
            [defaultselected]="detail.comptePaiement"
            [defaultsearch]="detail.comptePaiement ? ((detail.comptePaiement.nomBanque ? (detail.comptePaiement.nomBanque + ' / ') : '') + detail.comptePaiement.numCompte) : ''">
          </app-autocomplete>
        </div>
        <div *ngIf="!droit.droitFicheCompta">
          {{ detail.comptePaiement ? ((detail.comptePaiement.nomBanque ? (detail.comptePaiement.nomBanque + ' / ') : '')
          + detail.comptePaiement.numCompte) : '' }}
        </div>
      </div>
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt231 && common.visibleChamp.cltObj231.visible">
    <label class="col-sm-3 champ" style="padding:0px">TEOM :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
        [disabled]="!edit || !droit.droitFicheCompta || (add && !common.visibleChamp.cltObj231.creation) || (!add && edit && !common.visibleChamp.cltObj231.modifiable)"
        [(ngModel)]="detail.isTEOM">
    </div>
  </div>
  <div class="form-group items col-sm-12"
    *ngIf="common.visibleChamp.clt231 && detail.isTEOM && common.visibleChamp.cltObj231.visible">
    <label class="col-sm-3 champ" style="padding:0px"> Montants TEOM :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="droit.droitFicheCompta" class="col-sm-12 champ text-underline historique" style="padding: 0px"
        [ngClass]="{'disabledbutton': add || (add && !common.visibleChamp.cltObj231.creation) || (!add && edit && !common.visibleChamp.cltObj231.modifiable)}"
        (click)="showMontantTEOM()">
        Valider
      </div>
      <div *ngIf="!droit.droitFicheCompta" class="col-sm-12 champ text-underline historique" style="padding: 0px"
        [ngClass]="{'disabledbutton': add || (add && !common.visibleChamp.cltObj231.creation) || (!add && edit && !common.visibleChamp.cltObj231.modifiable)}">
      </div>
    </div>
  </div>

  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt234">
    <label class="col-sm-3 champ" style="padding:0px">Code Service Chorus :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit && common.visibleChamp.cltObj234.vision"> {{ (detail.codeServiceChorus || '') }}
      </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.codeServiceChorus" 
        [hidden]="!common.visibleChamp.cltObj234.vision"
        [disabled]="!droit.droitFicheCompta || (add && !common.visibleChamp.cltObj234.creation) || (!add && edit && !common.visibleChamp.cltObj234.modifiable)">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt235">
    <label class="col-sm-3 champ" style="padding:0px">Num Engagement Chorus :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit&& common.visibleChamp.cltObj235.vision"> {{ (detail.numEngagementChorus || '') }}
      </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.numEngagementChorus" 
        [hidden]="!common.visibleChamp.cltObj235.vision"
        [disabled]="!droit.droitFicheCompta || (add && !common.visibleChamp.cltObj235.creation) || (!add && edit && !common.visibleChamp.cltObj235.modifiable)">
    </div>
  </div>
</div>

<ng-template #listeRum>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Liste des RUM : </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modalFicheClient" style="height: auto">
    <div class="col-sm-12 ligneBon" style="padding: 0px; height: 300px;">
      <ngx-datatable style="height: 100%" class="material" [rows]="listDesRUM || []" [columnMode]="'force'"
        [headerHeight]="35" [footerHeight]="0" [rowHeight]="40" [selectionType]="'checkbox'"
        [messages]="{emptyMessage: 'Pas de lignes à afficher'}" [loadingIndicator]="loadingIndicator">
        <ngx-datatable-column prop="numRum">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Num Rum </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <div *ngIf="!edit && !add" style="margin-top : 7px">
                {{ value }} 
            </div>
            <div *ngIf="edit || add">
                <input type="text" class="form-control" [(ngModel)]="row.numRum">
            </div>
          </ng-template>
        </ngx-datatable-column>
        
        <ngx-datatable-column prop="dateFiltreDeb">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Date début </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <div *ngIf="!edit && !add" style="margin-top : 7px">
                <span> {{row.dateDebut || ''}} </span>
            </div>
            <div *ngIf="edit || add">
              <app-input-date [class]="'form-control'" [id]="'date' + rowIndex"
                [model]="row.modelDebut"
                (changefct)="row.modelDebut = $event; changeDateDebut($event, row); showDate = true"
                [placeholder]="'Date debut'" [position]="listeTgap && listeTgap.length > 10 ? 'top-left' : 'bottom-left'"
                (keyenterfct)="common.changeDate($event, row.modelDebut, '#dateF' + rowIndex);"
                (selectfct)="selectDate($event, '#saveRum');" [showDatepicker]="true" [container]="true"
                [closeDatepickerOnSelect]="true">
              </app-input-date>
            </div>
          </ng-template>
        </ngx-datatable-column>
        
        <ngx-datatable-column prop="dateFiltreFin">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Date fin </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <div *ngIf="!edit && !add" style="margin-top : 7px">
                <span> {{row.dateFin || ''}} </span>
            </div>
            <div *ngIf="edit || add">
              <app-input-date [class]="'form-control'" [id]="'dateF' + rowIndex"
                [model]="row.modelFin" (changefct)="row.modelFin = $event; changeDateFin($event, row); showDate = true"
                [placeholder]="'Date fin'"
                (keyenterfct)="common.changeDate($event, row.modelFin, '#valeur' + rowIndex); "
                (selectfct)="selectDate($event, '#saveRum');" [showDatepicker]="true" [container]="true"
                [closeDatepickerOnSelect]="true">
              </app-input-date>
            </div>              
          </ng-template>
        </ngx-datatable-column>
        
        <ngx-datatable-column *ngIf="edit || add" [width]="50" [sortable]="false" [canAutoResize]="false" 
            [draggable]="false" [resizeable]="false">
            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                <div class="text-right" style="padding-right: 5px;">
                    <button class="btn-detail" (click)="deleteLigneRum(row)">
                      <i class="fa fa-trash"></i>
                    </button>
                </div>
            </ng-template>
        </ngx-datatable-column>        
      </ngx-datatable>
    </div>
      
    <div class="col-sm-12" style="margin-top: 15px; padding: 0px;">
      <div *ngIf="edit || add" class="text-left col-sm-5 addLigne" style="padding: 0px;">
        <button class="btn-add" id="addLigne" (click)="addLigneRum()">
          <i class="fa fa-plus"></i>
        </button>
        <span> Ajouter une ligne</span>            
      </div>
        
      <div class="text-right" [ngClass]="{'col-sm-7' : edit || add, 'col-sm-12' : !edit}" style="padding: 0px;">
        <button type="button" class="btn-close" (click)="common.closeModal();">
          Fermer
        </button>
        <button *ngIf="edit || add" id="saveRum" type="button" class="btn-close btn-valider" (click)="enregistrerRum(); common.closeModal();">
          Enregistrer
        </button>        
      </div>
    </div>
  </div>
</ng-template>